import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import ChevronDown from "../svg/icons/IconChevronDown"

const NavBarMenuSolutions = ({ showMenu, setShowMenu }) => {
  const { t } = useTranslation()

  return (
    <div className="menu">
      <Link
        to="/industries/"
        className="nav-bar__btn"
        onClick={e => {
          e.preventDefault()
          setShowMenu()
        }}
      >
        <span>{t("navigation.solutions.nav-title")}</span>
        <ChevronDown
          className={`menu-icon ${showMenu ? "menu-icon__rotate" : ""}`}
        />
      </Link>
      <div
        className={`menu__mega-menu ${showMenu ? "menu__mega-menu--open" : ""}`}
      >
        {showMenu && (
          <>
            <div className="menu__mega-menu-container">
              <div className="menu__main menu__main--solutions">
                <div className="menu__main-lists">
                  <div className="menu__main-list">
                    <p className="menu__main-list-title p--sm">
                      {t("navigation.solutions.business-type")}
                    </p>
                    <div className="menu__main-list--business-types">
                      <Link
                        to="/industries/crm-for-startups/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.startups")}
                      </Link>
                      <Link
                        to="/industries/crm-small-business/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.small-business")}
                      </Link>
                      <Link
                        to="/industries/crm-for-medium-sized-businesses/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.mid-sized-business")}
                      </Link>
                      <Link
                        to="/ultimate/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.large-scale")}
                      </Link>
                    </div>
                  </div>
                  <div className="menu__main-list">
                    <p className="menu__main-list-title p--sm">
                      {t("navigation.solutions.industries")}
                    </p>
                    <div className="menu__main-list--industries">
                      <Link
                        to="/industries/crm-for-professional-services/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.professional-services")}
                      </Link>
                      <Link
                        to="/industries/crm-for-hotels-and-hospitality/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.hotels-hospitality")}
                      </Link>
                      <Link
                        to="/industries/crm-for-technology-services/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.technology")}
                      </Link>
                      <Link
                        to="/industries/crm-for-manufacturers/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.manufacturers")}
                      </Link>
                      <Link
                        to="/industries/crm-for-travel-agencies/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.travel-tourism")}
                      </Link>
                      <Link
                        to="/industries/crm-for-real-estate/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.real-estate")}
                      </Link>
                      <Link
                        to="/industries/crm-for-construction/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.construction")}
                      </Link>
                      <Link
                        to="/industries/crm-for-architects/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.architects")}
                      </Link>
                      <Link
                        to="/industries/crm-for-schools/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.schools")}
                      </Link>
                      <Link
                        to="/industries/crm-for-accountants/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.accountants")}
                      </Link>
                      <Link
                        to="/industries/crm-for-recruitment/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.recruitment")}
                      </Link>
                      <Link
                        to="/industries/crm-for-law/"
                        className="menu__item-title mb-6 mr-9"
                      >
                        {t("navigation.solutions.legal")}
                      </Link>
                    </div>
                    <Link
                      to="/industries/"
                      className="menu__item-link menu__item-link--mobile"
                    >
                      <strong>{t("navigation.solutions.footer-link-1")}</strong>
                    </Link>
                  </div>
                </div>
              </div>
              <aside className="menu__aside-container">
                <Link
                  className="menu__aside menu__aside--solutions"
                  to="/features/growth/"
                >
                  <div>
                    <img
                      src="/icons/signup/growth.svg"
                      alt="Growth plan icon"
                      role="presentation"
                      className="menu__aside-item-icon"
                    />
                  </div>
                  <div>
                    <p className="mb-1 text-link text-link--dark">
                      <strong>
                        {t("navigation.solutions.aside-item-1.title")}
                      </strong>
                    </p>
                    <p className="p--sm">
                      {t("navigation.solutions.aside-item-1.description")}
                    </p>
                  </div>
                </Link>
                <Link
                  className="menu__aside menu__aside--solutions"
                  to="/ultimate/"
                >
                  <div>
                    <img
                      src="/icons/signup/ultimate.svg"
                      alt="Ultimate plan icon"
                      role="presentation"
                      className="menu__aside-item-icon"
                    />
                  </div>
                  <div>
                    <p className="mb-1 text-link text-link--dark">
                      <strong>
                        {t("navigation.solutions.aside-item-2.title")}
                      </strong>
                    </p>
                    <p className="p--sm">
                      {t("navigation.solutions.aside-item-2.description")}
                    </p>
                  </div>
                </Link>
              </aside>
            </div>
            <div className="menu__footer">
              <div className="menu__footer-container">
                <div className="menu__footer-links">
                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/industries/"
                  >
                    {t("navigation.solutions.footer-link-1")}
                  </Link>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/crm-comparisons/"
                  >
                    {t("navigation.solutions.footer-link-2")}
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
export default NavBarMenuSolutions
